export default "__VITE_ASSET__1c6d940e__"